module.exports = __webpack_public_path__ + "d8b6641377b453fcb3658f751c87a3d5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-30.png
// module id = 1646
// module chunks = 0